/**
 * Chat routing guard utilities.
 * Used to detect standalone Q&A questions and strip debug headers from responses.
 * Extracted for testability.
 */

/**
 * Returns true if the user message looks like a standalone educational/Q&A question
 * rather than a product description or clarification answer.
 */
export function isStandaloneQuestion(text: string): boolean {
  const t = text.toLowerCase().trim();
  if (!t) return false;
  return (
    t.endsWith("?") ||
    t.startsWith("šta ") ||
    t.startsWith("sta ") ||
    t.startsWith("što ") ||
    t.startsWith("sto ") ||
    t.startsWith("ko ") ||
    t.startsWith("kako ") ||
    t.startsWith("gdje ") ||
    t.startsWith("gde ") ||
    t.startsWith("zašto ") ||
    t.startsWith("zasto ") ||
    t.startsWith("da li ") ||
    t.startsWith("jel ") ||
    t.startsWith("je li ")
  );
}

/**
 * Strips domain routing debug headers that may appear in backend responses.
 * These headers are meant for audit logs only and should not be shown in UI.
 */
export function stripDebugHeaders(text: string): string {
  return text
    .replace(/\n{0,2}###\s*Domenski\s+routing[\s\S]*?(?=\n###\s*[A-ZČĆŽŠĐ]|\n[A-ZČĆŽŠĐ][a-zčćžšđ]|$)/gi, "")
    .replace(/\n?-\s*domain:\s*\S+(\s|$)/gim, "\n")
    .replace(/\n?-\s*confidence:\s*\S+(\s|$)/gim, "\n")
    .replace(/\n?-\s*audit_triggers:\s*\S+(\s|$)/gim, "\n")
    .replace(/\n{3,}/g, "\n\n")
    .trim();
}
